/** Must match `LaunchDarklyFeatures.FunctionHealthStripePrimaryForNewActions` (Encounter service). */
export const stripeFunctionHealthPrimaryForNewActions =
  "stripe-function-health-primary-for-new-actions";

/** Must match `LaunchDarklyFeatures.MemberDigitalReportViaReporter`. */
export const memberDigitalReportViaReporter =
  "member-digital-report-via-reporter";

export const memberScanVideoSharing = "member-scan-video-sharing";

/** String flag: comma-separated package IDs MyEzra must not offer for booking. */
export const myEzraBlockedBookingPackageIds =
  "myezra-blocked-booking-package-ids";
